'use strict';

/* Controllers */

angular.module('substoreApp.controllers', []);
